// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fm8i","top":"styles_top__3xyNt","left":"styles_left__1qkmx","description":"styles_description__1z4zr"};